import { useL } from "@/lib/useL";
import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Swipe left/right on touch screens; a swipe never flips the card.
export function SwipeArea({ onPrev, onNext, children }) {
  const start = useRef(null);
  const swiped = useRef(false);
  const onTouchStart = (e) => { start.current = [e.touches[0].clientX, e.touches[0].clientY]; swiped.current = false; };
  const onTouchEnd = (e) => {
    if (!start.current) return;
    const dx = e.changedTouches[0].clientX - start.current[0];
    const dy = e.changedTouches[0].clientY - start.current[1];
    start.current = null;
    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
    swiped.current = true;
    (dx < 0 ? onNext : onPrev)();
  };
  const onClickCapture = (e) => { if (swiped.current) { e.stopPropagation(); e.preventDefault(); swiped.current = false; } };
  return <div onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} onClickCapture={onClickCapture} className="touch-pan-y" data-testid="card-swipe-area">{children}</div>;
}

const nav = "p-3 border-2 border-[#002FA7] text-[#002FA7] dark:border-blue-400 dark:text-blue-300 hover:bg-[#002FA7] hover:text-white transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-[#002FA7]";

export function CardArrows({ pos, total, onPrev, onNext, prevDisabled, nextDisabled, testid = "card-nav" }) {
  const L = useL();
  return (
    <div className="flex items-center justify-between mt-4" data-testid={testid}>
      <button type="button" className={nav} onClick={onPrev} disabled={prevDisabled} aria-label={L("Carte précédente", "Previous card")} data-testid={`${testid}-prev`}><ChevronLeft className="w-5 h-5" /></button>
      <span className="font-mono text-sm" data-testid={`${testid}-counter`}>{pos} / {total}</span>
      <button type="button" className={nav} onClick={onNext} disabled={nextDisabled} aria-label={L("Carte suivante", "Next card")} data-testid={`${testid}-next`}><ChevronRight className="w-5 h-5" /></button>
    </div>
  );
}
